export interface CompanyReference {
  companyId?: string | null;
  companyName?: string | null;
}

export function areDifferentCompanies(first: CompanyReference, second: CompanyReference): boolean {
  const firstId = normalize(first.companyId);
  const secondId = normalize(second.companyId);

  if (firstId && secondId) {
    return firstId !== secondId;
  }

  const firstName = normalize(first.companyName);
  const secondName = normalize(second.companyName);

  if (firstName && secondName) {
    return firstName !== secondName;
  }

  return false;
}

function normalize(value?: string | null): string | null {
  return value?.trim().toLowerCase() || null;
}
